import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ExternalLink, Play, ShoppingCart, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles.css';

function Shop() {
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState({ telegram_link: '#', telegram_username: '@admin' });
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Параллельная загрузка товаров и настроек
    Promise.all([
      axios.get('/api/products'),
      axios.get('/api/settings')
    ]).then(([prodRes, settRes]) => {
      setProducts(prodRes.data);
      setSettings(settRes.data);
      setLoading(false);
    }).catch(error => {
      console.error("Ошибка при загрузке:", error);
      setLoading(false);
    });
  }, []);

  const filteredProducts = products.filter(p => {
    if (filter === 'all') return true;
    return p.category === filter;
  });

  const getMainImage = (imageValue) => {
    if (!imageValue) return '';

    if (typeof imageValue === 'string' && imageValue.trim().startsWith('[')) {
      try {
        const parsed = JSON.parse(imageValue);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed[0];
        }
      } catch (error) {
        return imageValue;
      }
    }

    return imageValue;
  };

  return (
    <div className="app-container">
      <div className="grid-bg"></div>

      <nav>
        <a href="/" className="logo">YOONIX<span className="dot">.</span><span>SHOP</span></a>
        <div className="nav-links">
          <a href="#assets">Ассеты</a>
          <a href={settings.telegram_link} target="_blank" rel="noreferrer" className="btn btn-primary btn-nav">Связь _&gt;</a>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-badge">Цифровые решения v2.0</div>
        <h1>
          Готовые <span className="violet">Сайты</span><br />
          и <span className="highlight">TG Боты</span>
        </h1>
        <p>Готовые цифровые активы для вашего бизнеса. Выбирайте, тестируйте в реальном времени и интегрируйте. Без предоплат — смотрите демо перед покупкой.</p>
        
        <div className="hero-buttons">
          <a href="#assets" className="btn btn-primary">
            Смотреть каталог
            <ShoppingCart size={20} />
          </a>
        </div>
      </section>

      <section id="assets" className="marketplace">
        <div className="section-header">
          <h2 className="glitch">ВИТРИНА //</h2>
          <div className="filters">
            <button className={`filter-btn ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>Всё</button>
            <button className={`filter-btn ${filter === 'bot' ? 'active' : ''}`} onClick={() => setFilter('bot')}>TG Боты</button>
            <button className={`filter-btn ${filter === 'web' ? 'active' : ''}`} onClick={() => setFilter('web')}>Сайты</button>
            <button className={`filter-btn ${filter === 'script' ? 'active' : ''}`} onClick={() => setFilter('script')}>Скрипты</button>
            <button className={`filter-btn ${filter === 'design' ? 'active' : ''}`} onClick={() => setFilter('design')}>Дизайн</button>
            <button className={`filter-btn ${filter === 'database' ? 'active' : ''}`} onClick={() => setFilter('database')}>Базы</button>
          </div>
        </div>

        {loading ? (
          <div className="loading">Загрузка данных системы...</div>
        ) : (
          <div className="grid">
            {filteredProducts.map(product => {
              const mainImage = getMainImage(product.image_url);

              return (
              <div className="card" key={product.id}>
                <div className="card-img" style={{ backgroundImage: `url(${mainImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <div className="tag-container">
                    {product.is_hit ? <span className="tag new">ХИТ</span> : null}
                    {product.is_new ? <span className="tag new" style={{backgroundColor: '#fff'}}>NEW</span> : null}
                    <span className={`tag ${product.category}`}>
                      {product.category.toUpperCase()}
                    </span>
                  </div>
                  {!mainImage || mainImage.includes('placeholder') ? '[ НЕТ СИГНАЛА ]' : ''}
                </div>
                <div className="card-body">
                  <h3 className="card-title">{product.title}</h3>
                  <p className="card-desc">{product.description}</p>
                  
                  <div className="card-footer">
                    <div className="price">
                      {Math.floor(product.price).toLocaleString()} <span>TJS</span>
                    </div>
                  </div>
                  
                  <div className="action-group">
                    <Link to={`/product/${product.id}`} className="btn-card btn-demo" style={{ borderColor: 'var(--lime)', color: 'var(--lime)', gridColumn: 'span 2' }}>
                      ПОДРОБНЕЕ <ArrowRight size={16} style={{marginLeft: '5px', display: 'inline', verticalAlign: 'middle'}}/>
                    </Link>
                  </div>
                </div>
              </div>
            )})}
          </div>
        )}
      </section>

      <section id="custom" className="cta">
        <h2>НУЖЕН УНИКАЛЬНЫЙ ПРОЕКТ?</h2>
        <p>Не нашли подходящее решение? Мы можем разработать бота или сайт с нуля по вашему техническому заданию.</p>
        <a href={settings.telegram_link} target="_blank" rel="noreferrer" className="btn btn-primary" style={{marginTop: '1rem'}}>
          Обсудить задачу <ExternalLink size={20} />
        </a>
      </section>

      <footer>
        <div className="footer-grid">
          <div className="logo" style={{fontSize: '1.2rem'}}>YOONIX<span className="dot">.</span><span>SHOP</span></div>
        </div>
        <div className="copy">
          Система активна. © {new Date().getFullYear()} Yoonix.shop v2.0
        </div>
      </footer>
    </div>
  );
}

export default Shop;